import Vue from 'vue'
import Vuex from 'vuex'
// import VuexPersist from 'vuex-persist'

import auth from './modules/auth.js'
import settings from './modules/settings.js'
import filters from './modules/filters.js'
import utils from './modules/utils.js'

Vue.use(Vuex)

/*const vuexPersist = new VuexPersist({
    key: 'app',
    storage: localStorage
})*/

export default new Vuex.Store({
    modules: {
        auth,
        settings,
        filters,
        utils
    },
    // plugins: [vuexPersist.plugin]
})
